import { createApi } from "@reduxjs/toolkit/query/react";

import { validatePhoneEndpoint } from "./endpoints";
import type { EmptyBaseQuery, ReducerPath, TagTypes } from "./platformApi.types";

const emptyBaseQuery: EmptyBaseQuery = async () => ({ data: null });

export const platformApiSlice = createApi<
  EmptyBaseQuery,
  ReturnType<typeof validatePhoneEndpoint>,
  ReducerPath,
  TagTypes
>({
  reducerPath: "platformApi",
  baseQuery: emptyBaseQuery,
  endpoints: (builder) => ({
    ...validatePhoneEndpoint(builder),
  }),
});

export const { useValidatePhoneMutation } = platformApiSlice;
